import { BsPeople } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';
import { useAuth } from '#globalContexts/AuthProvider';
import { useOrgMembers, useOrgCredits } from '#orgFeature/models/org/queries';

import { CreditPool } from './components/CreditPool';
import { MemberList } from './components/MemberList';
import { PendingInviteList } from './components/PendingInviteList';
import { formatRenewal } from './creditTypes';

const SECTION_PROPS = {
	icon: BsPeople,
	title: 'Team & Credits',
	subtitle: 'Wer darf wie viel suchen – und wie viel ist diesen Monat noch da.',
};

export const TeamSettings = () => {
	const { user, orgRole, orgSeats } = useAuth();
	const { data: { members = [], invites = [] } = {}, isLoading: membersLoading } = useOrgMembers(orgRole);
	const { data: orgCredits, isLoading: creditsLoading } = useOrgCredits(orgRole);

	if (membersLoading || creditsLoading) {
		return (
			<SectionCard {...SECTION_PROPS}>
				<div className="flex items-center justify-center py-12">
					<div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-500 border-t-transparent" />
				</div>
			</SectionCard>
		);
	}

	const quotas = {
		company: orgCredits?.pool.company.quota ?? 0,
		contact: orgCredits?.pool.contact.quota ?? 0,
	};

	return (
		<SectionCard {...SECTION_PROPS} className="overflow-visible">
			<div className="space-y-5 p-2">
				{orgCredits && <CreditPool pool={orgCredits.pool} renewsAt={orgCredits.renewsAt} />}

				<MemberList
					members={members}
					currentUserId={user?.id}
					orgRole={orgRole}
					quotas={quotas}
					renewal={formatRenewal(orgCredits?.renewsAt)}
					totalSeats={orgSeats?.seatsIncluded ?? 1}
				/>

				<PendingInviteList invites={invites} />
			</div>
		</SectionCard>
	);
};
